module.exports = __webpack_public_path__ + "img/car-orange.867be829.svg";